module.exports = __webpack_public_path__ + "static/media/image0.42ecea53.jpeg";